/* Oxi-Colon production UI + cart v8. All cart writes are serialized. */
(() => {
  "use strict";
  const ROOT=document.getElementById("omba-oxi-colon-root") || document.body;
  if(!ROOT || ROOT.dataset.initialized)return;
  const CFG=JSON.parse(document.getElementById("omba-oxi-colon-config").textContent);
  const registry=window.OMBACartRegistry;
  if(!registry)throw new Error("Falta el registro de productos OMBA");
  ROOT.dataset.initialized="true";
  const VID=String(CFG.variantId),OFERTA=CFG.offers;
  const ES_SHOPIFY=!!window.Shopify?.shop,RUTA=window.Shopify?.routes?.root || "/";
  const $=(s,r=ROOT)=>r.querySelector(s),$$=(s,r=ROOT)=>[...r.querySelectorAll(s)];
  const mx=n=>new Intl.NumberFormat("es-ES",{style:"currency",currency:"EUR"}).format(n);
  let N=2,activeDialog=null,previousFocus=null,previousOverflow="",backgroundState=[];
  let queue=Promise.resolve(),checkoutBusy=false,pending=0;
  const cartError=$("#cartError"),status=$("#cartStatus"),go=$("#cGo");
/* OMBA_COMPLEMENTOS_OXI_V6 */
const complementoSelectors={"#cart":"#cart","[data-total]":"#cTot","[data-old]":"#cOld","[data-savebox]":"#cAh"};
const complementoDOM={querySelector:selector=>ROOT.querySelector(complementoSelectors[selector]||selector)};
const complementosV3=window.OMBAComplementosV3.attach({config:window.OMBAComplementosConfigV3["es-oxi"],shopify:ES_SHOPIFY,root:complementoDOM,request:request,parentQuantity:()=>OFERTA[N].q,parentTotalCents:()=>Math.round(OFERTA[N].p*100),busy:()=>checkoutBusy||pending>0,enqueue:fn=>{const task=queue.then(fn);queue=task.catch(()=>{});return task;}});
function paint(){paintBase();complementosV3.render();}

  const incoming=new URLSearchParams(location.search);
  const attribution=()=>{
    const params=new URLSearchParams();
    for(const [k,v] of incoming)if(/^utm_/i.test(k)||["fbclid","gclid","ttclid"].includes(k))params.set(k,v);
    return params;
  };
  // Match the published 5–15 business-day policy using the store calendar.
  function deliveryRange(now=new Date()){
    const parts=Object.fromEntries(new Intl.DateTimeFormat("en-CA",{timeZone:"Europe/Madrid",year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(now).map(p=>[p.type,p.value]));
    const start=new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day));
    const advance=count=>{const d=new Date(start);while(count){d.setUTCDate(d.getUTCDate()+1);if(d.getUTCDay()!==0&&d.getUTCDay()!==6)count--;}return d;};
    const format=d=>new Intl.DateTimeFormat("es-ES",{day:"numeric",month:"long",timeZone:"UTC"}).format(d);
    return `Recíbelo gratis entre el ${format(advance(5))} y el ${format(advance(15))}`;
  }
  function updateDelivery(){const range=deliveryRange();$$("[data-delivery-range]").forEach(el=>el.textContent=range);}
  updateDelivery();window.addEventListener("pageshow",updateDelivery);
  document.addEventListener("visibilitychange",()=>{if(!document.hidden)updateDelivery();});
  setInterval(()=>{if(!document.hidden)updateDelivery();},60000);
  function checkoutURL(codes){
    const params=attribution();
    params.set("discount",codes.join(","));params.set("country","ES");params.set("currency","EUR");
    return RUTA+"checkout?"+params;
  }
  function controls(){
    go.disabled=checkoutBusy;
    go.setAttribute("aria-busy",String(checkoutBusy));
    go.textContent=checkoutBusy?"Preparando tu pago…":"Pagar ahora · envío gratis";
    $$("#editPack,#packs .pk").forEach(b=>b.disabled=checkoutBusy);
    status.textContent=pending?"Actualizando tu carrito…":"";
    ROOT.dataset.cartBusy=String(pending>0||checkoutBusy);
    complementosV3.render();
  }
  function showError(error){
    cartError.hidden=false;
    cartError.textContent=error?.status===422?"Este paquete no está disponible. Elige otro o contacta con nosotros.":
      error?.code==="currency"?"No hemos podido confirmar los precios en euros. Recarga la página y vuelve a intentarlo.":
      error?.code==="discount"?"No hemos podido confirmar el descuento de tu paquete. Pulsa Pagar ahora para reintentar.":
      "No hemos podido actualizar tu carrito. Revisa tu conexión y pulsa Pagar ahora para reintentar.";
  }
  function queued(task){
    pending++;controls();
    const result=queue.then(task);
    queue=result.catch(()=>{}).finally(()=>{pending--;controls();});
    return result;
  }
  async function request(path,body,method="POST"){
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),20000);
    try{
      const response=await fetch(RUTA+path,{method,credentials:"same-origin",cache:"no-store",headers:{"Accept":"application/json",...(body===undefined?{}:{"Content-Type":"application/json"})},body:body===undefined?undefined:JSON.stringify(body),signal:controller.signal});
      const data=await response.json();
      if(!response.ok)throw Object.assign(new Error(data.description||"No se pudo actualizar el carrito"),{status:response.status});
      return data;
    }finally{clearTimeout(timeout);}
  }
  const own=cart=>(cart.items||[]).filter(i=>String(i.variant_id||i.id)===VID);
  const quantity=cart=>own(cart).reduce((sum,i)=>sum+i.quantity,0);
  function cartInfo(cart){
    const others=(cart.items||[]).filter(i=>String(i.variant_id||i.id)!==VID);
    $("#cartOtherItems").hidden=!others.length;
    $("#cartTotalLabel").textContent=others.length?"Este paquete":"Total";
  }
  function validateCurrency(cart){
    if(cart.currency&&cart.currency!==CFG.currency)throw Object.assign(new Error("Moneda no confirmada"),{code:"currency"});
  }
  async function synchronize(pack){
    if(!ES_SHOPIFY)return null;
    const desired=OFERTA[pack].q;
    let cart=await request("cart.js",undefined,"GET");validateCurrency(cart);
    if(quantity(cart)!==desired){
      // Re-read keys after each change: Shopify may replace keys when discounts change.
      while(own(cart).length>1){
        const last=own(cart).at(-1);
        cart=await request("cart/change.js",{id:last.key,quantity:0});
      }
      const line=own(cart)[0];
      if(line){
        cart=await request("cart/change.js",{id:line.key,quantity:desired});
      }else{
        await request("cart/add.js",{items:[{id:Number(VID),quantity:desired}]});
        cart=await request("cart.js",undefined,"GET");
      }
    }
    if(quantity(cart)!==desired)throw new Error("Cantidad no confirmada");
    validateCurrency(cart);cartInfo(cart);cartError.hidden=true;
    return cart;
  }
  async function discounts(pack){
    const cart=await request("cart.js",undefined,"GET");
    validateCurrency(cart);
    if(quantity(cart)!==OFERTA[pack].q)throw new Error("El carrito cambió");
    const codes=registry.codes(cart,(incoming.get("discount")||"").split(","));
    if(!codes.includes(OFERTA[pack].c))throw Object.assign(new Error("Código faltante"),{code:"discount"});
    const updated=await request("cart/update.js",{discount:codes.join(",")});
    validateCurrency(updated);
    if(quantity(updated)!==OFERTA[pack].q)throw new Error("El carrito cambió");
    const applied=updated.discount_codes?.find(c=>c.code.toUpperCase()===OFERTA[pack].c);
    if(applied?.applicable===false)throw Object.assign(new Error("Descuento rechazado"),{code:"discount"});
    const lines=own(updated);
    if(lines.every(i=>Number.isFinite(i.final_line_price))&&lines.reduce((sum,i)=>sum+i.final_line_price,0)!==Math.round(OFERTA[pack].p*100))
      throw Object.assign(new Error("Total de paquete incorrecto"),{code:"discount"});
    cartInfo(updated);return codes;
  }
  function paintBase(){
    const o=OFERTA[N],top=N===3,saving=o.t-o.p;
    $$("[data-pack-price]").forEach(el=>el.textContent=mx(o.p));
    $$("[data-pack-free]").forEach(el=>el.textContent=`${o.regalo} ${o.regalo===1?"frasco gratis":"frascos gratis"}`);
    $("#cCount").textContent=`(${o.q} frascos)`;
    $("#cT").textContent=o.lbl;$("#cP").textContent=mx(o.p);
    $("#cS").textContent=`${o.q} frascos · Pagas ${o.regalo} y recibes ${o.q}`;
    $("#cGift").textContent=`Regalos gratis: ${o.regalo} ${o.regalo===1?"frasco":"frascos"} + 2 guías`;
    $("#cTope").hidden=!top;
    if(top) $("#cTs").textContent=`${o.porciones} porciones · ${o.regalo} frascos de regalo + 2 guías gratis`;
    $("#cPt").textContent=top?"Máximo descuento":`Ahorro en tu pack · nivel ${N} de 3`;
    $("#cPe").textContent=Math.round(saving/o.t*100)+"% menos";
    $("#cBar").style.width=Math.round(N/3*100)+"%";
    $("#cAh").textContent=`Ahorras ${mx(saving)}`;$("#cOld").textContent=mx(o.t);$("#cTot").textContent=mx(o.p);
  }
  function pick(n){
    if(checkoutBusy||!OFERTA[n])return;
    N=n;$$("#packs .pk").forEach(p=>{const selected=+p.dataset.n===n;p.classList.toggle("on",selected);p.setAttribute("aria-pressed",String(selected));});
    $("#stickyP").textContent=mx(OFERTA[n].p);$("#stickyPack").textContent=`${OFERTA[n].porciones} porciones · ${OFERTA[n].q} frascos`;
    paint();if(activeDialog===$("#cart"))queued(()=>synchronize(n)).then(()=>complementosV3.refresh()).catch(showError);
  }
  function dialog(id,on){
    const el=$(id);
    if(on){
      updateDelivery();
      if(activeDialog===el)return;
      if(activeDialog)dialog("#"+activeDialog.id,false);
      previousFocus=document.activeElement;previousOverflow=document.body.style.overflow;activeDialog=el;
      backgroundState=[...ROOT.children].filter(e=>![el,$("#scrim")].includes(e)&&!["SCRIPT","STYLE","SVG","LINK"].includes(e.tagName)).map(e=>[e,e.inert]);
      backgroundState.forEach(([e])=>e.inert=true);el.inert=false;el.setAttribute("aria-hidden","false");el.classList.add("on");document.body.style.overflow="hidden";
      if(id==="#cart")$("#scrim").classList.add("on");
      $("button",el)?.focus({preventScroll:true});
    }else{
      if(activeDialog!==el)return;
      if(id==="#ugcDialog")$("#ugcPlayer")?.pause();
      el.classList.remove("on");el.setAttribute("aria-hidden","true");el.inert=true;$("#scrim").classList.remove("on");
      backgroundState.forEach(([e,inert])=>e.inert=inert);document.body.style.overflow=previousOverflow;activeDialog=null;
      $("#sticky").inert=!$("#sticky").classList.contains("on");
      if(previousFocus?.isConnected)previousFocus.focus({preventScroll:true});
    }
    $$("[data-open-cart]").forEach(b=>b.setAttribute("aria-expanded",String(activeDialog===$("#cart"))));
  }
  $$("#packs .pk").forEach(p=>p.onclick=()=>pick(+p.dataset.n));
  $$("[data-open-cart]").forEach(b=>{b.setAttribute("aria-controls","cart");b.setAttribute("aria-expanded","false");b.onclick=()=>{paint();dialog("#cart",true);const n=N;queued(()=>synchronize(n)).then(()=>complementosV3.refresh()).catch(showError);};});
  $("#closeCart").onclick=$("#scrim").onclick=()=>dialog("#cart",false);
  $("#editPack").onclick=()=>{dialog("#cart",false);$("#packs").scrollIntoView({block:"center"});$("#packs .pk.on").focus({preventScroll:true});};
  go.onclick=async()=>{
    if(checkoutBusy)return;
    if(!ES_SHOPIFY){const p=attribution();p.set("omba_pack",String(N));p.set("open_cart","1");p.set("country","ES");location.assign(CFG.canonical+"?"+p);return;}
    checkoutBusy=true;cartError.hidden=true;controls();const pack=N;
    try{
      const codes=await queued(async()=>{await synchronize(pack);return discounts(pack);});
      await complementosV3.beforeCheckout();
      location.assign(checkoutURL(codes));
    }catch(error){showError(error);checkoutBusy=false;controls();}
  };
  window.addEventListener("pageshow",()=>{checkoutBusy=false;controls();});
  document.addEventListener("keydown",e=>{
    if(!activeDialog)return;
    if(e.key==="Escape"){e.preventDefault();dialog("#"+activeDialog.id,false);return;}
    if(e.key!=="Tab")return;
    const items=$$("button:not([disabled]),a[href],input:not([disabled]),[tabindex='0']",activeDialog).filter(e=>e.getClientRects().length&&!e.closest("[hidden]")),first=items[0],last=items.at(-1);
    if(!first)return;
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
  $$("[data-facts]").forEach(b=>{b.setAttribute("aria-controls","facts");b.onclick=()=>dialog("#facts",true);});
  $("[data-close-facts]").onclick=()=>dialog("#facts",false);
  $("#facts").onclick=e=>{if(e.target.id==="facts")dialog("#facts",false);};
  const ugcRail=$("#ugcRail"),ugcPlayer=$("#ugcPlayer"),ugcTrack=$("#ugcCaptions");
  if(ugcRail&&ugcPlayer&&ugcTrack){
  const syncUgcArrows=()=>{
    $("#ugcPrev").disabled=ugcRail.scrollLeft<2;
    $("#ugcNext").disabled=ugcRail.scrollLeft+ugcRail.clientWidth>=ugcRail.scrollWidth-2;
  };
  const moveUgc=direction=>{
    const card=$(".ugc-card",ugcRail);
    ugcRail.scrollBy({left:direction*(card.getBoundingClientRect().width+12),behavior:matchMedia("(prefers-reduced-motion:reduce)").matches?"instant":"smooth"});
  };
  $("#ugcPrev").onclick=()=>moveUgc(-1);$("#ugcNext").onclick=()=>moveUgc(1);
  ugcRail.addEventListener("scroll",syncUgcArrows,{passive:true});
  ugcRail.addEventListener("keydown",e=>{if(e.target===ugcRail&&["ArrowLeft","ArrowRight"].includes(e.key)){e.preventDefault();moveUgc(e.key==="ArrowRight"?1:-1);}});
  if("ResizeObserver" in window)new ResizeObserver(syncUgcArrows).observe(ugcRail);
  syncUgcArrows();
  $("[data-close-ugc]").onclick=()=>dialog("#ugcDialog",false);
  $("#ugcDialog").onclick=e=>{if(e.target.id==="ugcDialog")dialog("#ugcDialog",false);};
  const showCaptions=()=>{if(ugcPlayer.textTracks[0])ugcPlayer.textTracks[0].mode="showing";};
  ugcTrack.addEventListener("load",showCaptions);ugcPlayer.addEventListener("loadedmetadata",showCaptions);
  ugcPlayer.addEventListener("error",()=>{$("#ugcError").hidden=false;});
  $$(".ugc-open").forEach(button=>button.onclick=()=>{
    ugcPlayer.pause();$("#ugcError").hidden=true;
    $("#ugcDialogTitle").textContent=button.dataset.title;
    $("#ugcOriginal").href=button.dataset.source;
    $("#ugcOriginal").textContent=button.dataset.origin+" · Ver original";
    ugcPlayer.poster=$("img",button).src;
    ugcTrack.src=button.dataset.captions;ugcPlayer.src=button.dataset.video;
    ugcPlayer.load();showCaptions();dialog("#ugcDialog",true);
    ugcPlayer.play().catch(()=>{/* Native play controls remain available after a browser gesture restriction. */});
  });
  }
  const gm=$("#galMain"),galleries=[$$("#thumbs button"),$$("#gdots button")];
  const gallerySize=gm?.children.length||1;
  const moveGallery=delta=>{const k=Math.round(gm.scrollLeft/gm.clientWidth);gm.scrollTo({left:((k+delta+gallerySize)%gallerySize)*gm.clientWidth});};
  $("#galleryPrev").onclick=()=>moveGallery(-1);$("#galleryNext").onclick=()=>moveGallery(1);
  gm.addEventListener("keydown",e=>{if(e.key==="ArrowRight"||e.key==="ArrowLeft"){e.preventDefault();moveGallery(e.key==="ArrowRight"?1:-1);}});
  gm.addEventListener("scroll",()=>{$("#galleryCount").textContent=`${Math.round(gm.scrollLeft/gm.clientWidth)+1} / ${gallerySize}`;},{passive:true});
  $("#cartReviews").onclick=()=>{dialog("#cart",false);$("#resenas").scrollIntoView({block:"start"});};
  galleries.forEach(buttons=>buttons.forEach((b,k)=>{b.setAttribute("aria-pressed",String(k===0));b.onclick=()=>gm.scrollTo({left:k*gm.clientWidth});}));
  gm?.addEventListener("scroll",()=>{const k=Math.round(gm.scrollLeft/gm.clientWidth);galleries.forEach(buttons=>buttons.forEach((d,j)=>{d.classList.toggle("on",j===k);d.setAttribute("aria-pressed",String(j===k));}));},{passive:true});
  const tabs=$$("#tabs .tb-h button"),panels=$$("#tabs .tb-b>div");
  $("#tabs .tb-h")?.setAttribute("role","tablist");
  const selectTab=k=>tabs.forEach((b,i)=>{b.classList.toggle("on",i===k);b.setAttribute("aria-selected",String(i===k));b.tabIndex=i===k?0:-1;panels[i].classList.toggle("on",i===k);});
  tabs.forEach((b,i)=>{b.id=`oxi-tab-${i}`;b.setAttribute("role","tab");b.setAttribute("aria-controls",`oxi-panel-${i}`);panels[i].id=`oxi-panel-${i}`;panels[i].setAttribute("role","tabpanel");panels[i].setAttribute("aria-labelledby",b.id);b.onclick=()=>selectTab(i);b.onkeydown=e=>{let k=i;if(e.key==="ArrowRight")k=(i+1)%tabs.length;else if(e.key==="ArrowLeft")k=(i+tabs.length-1)%tabs.length;else if(e.key==="Home")k=0;else if(e.key==="End")k=tabs.length-1;else return;e.preventDefault();selectTab(k);tabs[k].focus();};});selectTab(0);
  $$("[data-mq]").forEach(track=>{
    const originals=[...track.children].map(child=>child.cloneNode(true));let width=0;
    const fill=()=>{
      const target=track.parentElement.clientWidth;if(!target)return;
      track.replaceChildren();const group=document.createElement("div");group.className="mq-group";track.appendChild(group);
      // Each of the two identical groups must cover the viewport before looping.
      do{originals.forEach(child=>group.appendChild(child.cloneNode(true)));}while(group.getBoundingClientRect().width<target);
      const clone=group.cloneNode(true);clone.setAttribute("aria-hidden","true");track.appendChild(clone);
      track.style.setProperty("--mq-duration",`${group.getBoundingClientRect().width/45}s`);width=target;
    };
    fill();document.fonts?.ready.then(fill);
    if("ResizeObserver" in window)new ResizeObserver(()=>{if(track.parentElement.clientWidth!==width)fill();}).observe(track.parentElement);
  });
  if("IntersectionObserver" in window){
    const reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add("in");reveal.unobserve(e.target);}}),{threshold:.15});
    $$(".reveal").forEach(e=>reveal.observe(e));
    new IntersectionObserver(([e])=>{const on=!e.isIntersecting&&e.boundingClientRect.bottom<=66;$("#sticky").classList.toggle("on",on);if(!activeDialog)$("#sticky").inert=!on;},{rootMargin:"-66px 0px 0px 0px"}).observe($("#comprar"));
  }else{$$(".reveal").forEach(e=>e.classList.add("in"));}
  const reduced=matchMedia("(prefers-reduced-motion:reduce)");
  const syncMotion=()=>{if(reduced.matches)$$('video[autoplay]').forEach(v=>v.pause());};
  reduced.addEventListener("change",syncMotion);syncMotion();pick([1,2,3].includes(+incoming.get("omba_pack"))?+incoming.get("omba_pack"):2);controls();
  if(ES_SHOPIFY && incoming.get("open_cart")==="1"){dialog("#cart",true);const n=N;queued(()=>synchronize(n)).then(()=>complementosV3.refresh()).catch(showError);}
})();
